import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="mx-auto flex min-h-[80vh] max-w-[1440px] flex-col justify-center px-5 pt-24 sm:px-8 lg:px-12">
      <p className="font-display text-[30vw] font-semibold leading-none text-outline-lime lg:text-[18vw]">404</p>
      <p className="mt-4 text-white/75">Esta página foi enterrada como um osso. Vamos voltar ao início?</p>
      <Link to="/" data-testid="not-found-home" className="mt-8 w-fit rounded-full bg-[#C8D484] px-7 py-4 font-bold text-black">Voltar ao início</Link>
    </section>
  );
}
